import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm, formValueSelector, arrayRemoveAll, change } from 'redux-form';
import PropTypes from 'prop-types';
import renderField from '../../../../shared/components/form/TextField';
import renderSelectField from '../../../../shared/components/form/Select';
import renderDatePickerField from '../../../../shared/components/form/DatePicker';
import store from '../../../App/store';
import validate from '../../validate';

class WizardFormOne extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor() {
    super();
    this.state = {
      showDates: false,
      showDays: false,
    };
  }

  componentDidMount() {
    const selector = formValueSelector('flows_create_form');
    const courseType = selector(store.getState(), 'courseType');

    if (courseType) {
      if (courseType.value === 'flow') {
        this.setState({ showDates: true });
      } else if (courseType.value === 'instant') {
        this.setState({ showDays: true });
      }
    }
  }

  handleChange = (type) => {
    const showDates = type.value === 'flow';
    const showDays = type.value === 'instant';
    this.setState({ showDates, showDays });
  };

  handleChangeCourse = () => {
    store.dispatch(arrayRemoveAll('flows_create_form', 'themes'));
    store.dispatch(change('flows_create_form', 'materials', {}));
  };

  render() {
    const { handleSubmit, asyncData } = this.props;
    const { showDates, showDays } = this.state;
    const { courses } = asyncData;

    return (
      <form className="form form--horizontal wizard__form" onSubmit={handleSubmit}>
        <h3 className="wizard__title">Заполните общею информацию о потоке</h3>
        <div className="form__form-group">
          <span className="form__form-group-label">Название потока</span>
          <div className="form__form-group-field">
            <Field name="name" component={renderField} type="text" placeholder="Название потока" />
          </div>
        </div>
        <div className="form__form-group form__form-select">
          <span className="form__form-group-label">Курс</span>
          <div className="form__form-group-field">
            <Field
              name="course"
              component={renderSelectField}
              placeholder="Выберите курс"
              options={courses}
              changeAction={this.handleChangeCourse}
            />
          </div>
        </div>
        <div className="form__form-group form__form-select">
          <span className="form__form-group-label">Тип курса</span>
          <div className="form__form-group-field">
            <Field
              name="courseType"
              component={renderSelectField}
              placeholder="Выберите тип курса"
              options={[
                { value: 'flow', label: 'Поток' },
                { value: 'instant', label: 'Моментальный' },
              ]}
              changeAction={this.handleChange}
            />
          </div>
        </div>
        {showDates && (
          <div className="form__form-group">
            <span className="form__form-group-label">Дата старта</span>
            <div className="form__form-group-field">
              <Field name="dateBegin" component={renderDatePickerField} />
            </div>
          </div>
        )}
        {showDates && (
          <div className="form__form-group">
            <span className="form__form-group-label">Дата окончания</span>
            <div className="form__form-group-field">
              <Field name="dateEnd" component={renderDatePickerField} />
            </div>
          </div>
        )}
        {showDates && (
          <div className="form__form-group">
            <span className="form__form-group-label">Доступен до</span>
            <div className="form__form-group-field">
              <Field name="dateAvailable" component={renderDatePickerField} />
            </div>
          </div>
        )}
        {showDays && (
          <div className="form__form-group">
            <span className="form__form-group-label">Окончание через N дней</span>
            <div className="form__form-group-field">
              <Field name="ending" component={renderField} type="number" placeholder="Количество дней" />
            </div>
          </div>
        )}
        {showDays && (
          <div className="form__form-group">
            <span className="form__form-group-label">Доступен количество дней</span>
            <div className="form__form-group-field">
              <Field name="days" component={renderField} type="number" placeholder="Количество дней" />
            </div>
          </div>
        )}
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" type="button" disabled className="previous">
            Предыдущий шаг
          </Button>
          <Button color="primary" type="submit" className="next">
            Следующий шаг
          </Button>
        </ButtonToolbar>
      </form>
    );
  }
}

export default reduxForm({
  form: 'flows_create_form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardFormOne);
